module.exports = __webpack_public_path__ + "static/media/7.108b3972.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/slides/7.jpg
// module id = 784
// module chunks = 0